import { render, staticRenderFns } from "./ProductIndex.vue?vue&type=template&id=1dc46566&"
import script from "./ProductIndex.vue?vue&type=script&lang=js&"
export * from "./ProductIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports